import { render, staticRenderFns } from "./ResultsStakeholderStandard.vue?vue&type=template&id=680b774e&"
import script from "./ResultsStakeholderStandard.vue?vue&type=script&lang=js&"
export * from "./ResultsStakeholderStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports